import { Routes } from '@angular/router';
import { crmLayoutOutletRoute } from '@touch4it/ng-swp/layout-v2';

import { authGuard } from '~/shared/guards/auth.guard';
import { roleGuard } from '~/shared/guards/role.guard';
import { adminRoles, allLoggedInRoles } from '~/shared/types/user.role';

export const appRoutes = {
  home: 'home',
  erp: 'erp',
  supplements: 'supplements',
  packagings: 'packagings',
  products: 'products',
  claims: 'claims',
  users: 'users',
  settings: 'settings',
} as const;

export const erpPaths = {
  supplements: `${appRoutes.erp}/${appRoutes.supplements}`,
  packagings: `${appRoutes.erp}/${appRoutes.packagings}`,
  products: `${appRoutes.erp}/${appRoutes.products}`,
  claims: `${appRoutes.erp}/${appRoutes.claims}`,
} as const;

const legacyErpModules = [appRoutes.products, appRoutes.supplements, appRoutes.packagings] as const;

export const legacyErpRedirects: Routes = legacyErpModules.flatMap((moduleName) => [
  {
    path: moduleName,
    pathMatch: 'full',
    redirectTo: `${appRoutes.erp}/${moduleName}`,
  },
  {
    path: `${moduleName}/:id`,
    redirectTo: `${appRoutes.erp}/${moduleName}/:id`,
  },
]);

export const routes: Routes = [
  crmLayoutOutletRoute({
    path: 'app',
    canMatch: [authGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: appRoutes.home,
      },
      {
        path: appRoutes.home,
        loadChildren: () => import('./features/home/routes'),
      },
      {
        canMatch: [roleGuard(allLoggedInRoles)],
        path: appRoutes.erp,
        loadChildren: () => import('./features/erp/routes'),
      },
      {
        canMatch: [roleGuard(adminRoles)],
        path: appRoutes.users,
        loadChildren: () => import('./features/users/routes'),
      },
      {
        canMatch: [roleGuard(adminRoles)],
        path: appRoutes.settings,
        loadChildren: () => import('./features/settings/routes'),
      },
      ...legacyErpRedirects,
      { path: '**', redirectTo: 'home' },
    ],
  }),
  {
    path: 'login',
    loadComponent: () => import('./features/login/login.component'),
  },
  { path: '**', redirectTo: 'app' },
];
